import { Reveal, SectionHeading } from "../Reveal";

const STEPS = [
    "Lead", "Medical Documents", "Clinical Review", "Treatment Quote", "Consultation",
    "Visa", "Travel", "Admission", "Treatment", "Discharge", "Follow-Up",
];

export default function HospitalOS() {
    return (
        <section data-testid="hospital-os-section" className="py-28 lg:py-36 bg-white">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
                    <div className="lg:col-span-5">
                        <SectionHeading
                            chapter="09"
                            eyebrow="The Future"
                            title="The International Patient Operating System."
                            description="We envision a future where hospitals can manage their international patient journey through one connected digital platform."
                            testid="hospital-os-heading"
                        />
                        <Reveal delay={0.3}>
                            <p data-testid="hospital-os-caption" className="mt-8 font-heading text-lg font-medium text-brand-blue">
                                From fragmented coordination to <span className="text-brand-green">one connected workflow.</span>
                            </p>
                        </Reveal>
                        <Reveal delay={0.4}>
                            <span data-testid="hospital-os-badge" className="mt-6 inline-flex items-center gap-2 rounded-full bg-tint-blue border border-brand-blue/10 px-5 py-2.5 text-xs font-bold uppercase tracking-wider text-brand-blue">
                                <span className="relative flex h-2 w-2">
                                    <span className="absolute inline-flex h-full w-full rounded-full bg-brand-green opacity-60 animate-ping" />
                                    <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-green" />
                                </span>
                                Coming as the platform evolves
                            </span>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-7">
                        <ol className="relative ml-4 border-l-2 border-slate-100" data-testid="hospital-os-timeline">
                            {STEPS.map((step, i) => (
                                <Reveal key={step} delay={0.05 * i} y={24}>
                                    <li className="relative pb-8 pl-10 last:pb-0 group" data-testid={`hospital-os-step-${i + 1}`}>
                                        <span className="absolute -left-[13px] top-0 flex h-6 w-6 items-center justify-center rounded-full border-2 border-slate-200 bg-white font-heading text-[10px] font-bold text-slate-400 group-hover:border-brand-green group-hover:text-brand-green transition-colors duration-300">
                                            {String(i + 1).padStart(2, "0")}
                                        </span>
                                        <span className="font-heading text-lg font-medium text-slate-700 group-hover:text-brand-blue transition-colors duration-300">
                                            {step}
                                        </span>
                                    </li>
                                </Reveal>
                            ))}
                        </ol>
                    </div>
                </div>
            </div>
        </section>
    );
}
